import template from './prepay-type.jade';
import validation from './../../../services/validation';
import prepayTypeOptions from '../../../enums/prepay-type';

const config = {
    default: {
        required: true
    },
    garage: {
        required: false
    }
};

export default angular
    .module('cian.addForm.prepayType', [])
    .directive('cianAfPriceAndDealTermsPrepayType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['categoryService', 'deviceService', function(categoryService, deviceService) {
            this.isMobile = deviceService.isMobile;
            this.items = prepayTypeOptions;

            this.validation = validation(this.form, 'bargainTerms.prepayType', {
                required: 'Укажите предоплату',
            });

            const {objectType} = categoryService.getInfoByCategory(this.ad.category);
            this.config = config[objectType] || config.default;
        }],
        controllerAs: 'prepayType',
        template,
    }))
    .name;
